import {
  deleteSSRCookie,
  getSSRCookie,
  setSSRCookie,
  TCookieOptions,
} from '@/common/cookies';
import { ILogoutTokenCookie } from '@/modules/auth/types';

const COOKIE_NAME = 'logoutToken';

export const setLogoutToken = (
  res: TServerSideResponse,
  value: ILogoutTokenCookie,
  options?: TCookieOptions
) => {
  setSSRCookie(res, COOKIE_NAME, value, options);
};

export const getLogoutToken = (req: TServerSideRequest) => {
  return getSSRCookie(req, COOKIE_NAME);
};

export const deleteLogoutToken = (res: TServerSideResponse) => {
  deleteSSRCookie(res, COOKIE_NAME);
};
